<template>
    <section
        v-if="currentLunch"
        class="todays-lunch"
    >
        <div class="inner">
            <div class="list">
                <div class="date">{{ today }}</div>
                <h3 class="h3">{{ $t('lunch') }}</h3>
                <div
                    v-for="item, key in currentLunch.products"
                    :key="`item-${key}`"
                    class="menu-item"
                >
                    <strong>{{ item.name }}</strong>
                    <strong class="price">{{ formatPrice(item.price) }}</strong>
                    <span
                        v-if="item.specialties"
                        class="attributes"
                    >{{ item.specialties.join(', ') }}</span>
                </div>
                <DSCFText
                    v-if="currentLunch.placeholderText"
                    :content="currentLunch.placeholderText"
                />
            </div>
            <DSFrontifyAsset
                v-if="currentLunch.image !== null"
                :asset="currentLunch.image"
                fill="cover"
            />
            <div v-if="pdfSource" class="pdf-download">
                <span class="title">{{ pdfSource.title }}</span>
                <nuxt-link
                    class="ds-btn ds-btn--primary"
                    :href="pdfSource.url"
                    target="_blank"
                >
                    {{ $t('open') }}
                    <DSIcon code="download" />
                </nuxt-link>
            </div>
        </div>
    </section>
</template>
<script setup>
import { useI18n } from '#imports';
import { mapState } from 'pinia';
import { usePageStore } from '~dsc/stores/cms/page';
import { DateTime } from 'luxon';

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            open: 'Avaa',
            lunch: 'Päivän lounas',
            time: 'klo',
            day: {
                Monday: 'Maanantai',
                Tuesday: 'Tiistai',
                Wednesday: 'Keskiviikko',
                Thursday: 'Torstai',
                Friday: 'Perjantai',
                Saturday: 'Lauantai',
                Sunday: 'Sunnuntai',
            },
        },
    },
});
</script>
<script>
export default {
    name: 'StationsLunch',
    props: {
        lunch: {
            type: [ Array ],
            required: false,
            default: null,
        },
    },
    computed: {
        ...mapState(usePageStore, ['station']),
        currentLunch() {
            const lunch = this?.lunch?.[0] || this.station?.lunch;

            return lunch?.currentLunch;
        },
        currentLunchTimeStamp() {
            const lunch = this?.lunch?.[0] || this.station?.lunch;

            return lunch?.currentLunchTimeStamp;
        },
        today() {
            if (this.currentLunchTimeStamp) {
                const currentLunchDay = DateTime.fromMillis(this.currentLunchTimeStamp);
                const timeData = [
                    this.$t(`day.${currentLunchDay.toFormat('cccc')}`),
                    currentLunchDay.toFormat('d.M.'),
                ];

                return timeData.join(' ');
            }

            return null;
        },
        pdfSource() {
            if (this.lunch !== null && this.lunch?.[0]?.pdf) {
                return this.lunch[0].pdf;
            } else if (this.station.lunch?.pdf) {
                return this.station.lunch.pdf;
            }

            return false;
        },
    },
    methods: {
        formatPrice(price) {
            return price;
        },
    },
};
</script>
<style scoped>
.todays-lunch {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.todays-lunch .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.todays-lunch .inner {
  display: grid;
  grid-template-columns: 1.5fr 2fr;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-image: linear-gradient(0deg, var(--color-secondary-500), var(--color-secondary-500));
}
.todays-lunch .list {
  align-self: center;
  padding: 3rem 1.5rem;
}
.todays-lunch .list .date {
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.todays-lunch .list .h3 {
  margin-top: 0;
}
.todays-lunch .list .menu-item {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.todays-lunch .list .menu-item:not(:last-child) {
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-base-grey-300);
}
.todays-lunch .list .menu-item .price {
  justify-self: end;
}
.todays-lunch .image-container {
  padding-top: 56.2%;
}
.todays-lunch .image-container,
.todays-lunch .pdf-download {
  grid-row-start: 1;
  grid-column-start: 2;
}
@media (max-width: 991px) {
  .todays-lunch .image-container,
  .todays-lunch .pdf-download {
    grid-row-start: 2;
    grid-column-start: 1;
  }
}
.todays-lunch .pdf-download {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  align-self: end;
  justify-self: center;
  width: calc(100% - 4rem);
  border-radius: 4px;
  padding: 1.5rem;
  margin: 1rem;
  background: var(--color-base-white);
}
.todays-lunch .pdf-download .title {
  max-width: 60%;
  font-weight: 700;
}
.todays-lunch .pdf-download .icon {
  margin-left: 0.75rem;
}
@media (max-width: 991px) {
  .todays-lunch .pdf-download {
    width: calc(100% - 3rem);
  }
}
@media (max-width: 991px) {
  .todays-lunch .inner {
    padding: 0;
    grid-template-columns: 1fr;
  }
  .todays-lunch .inner .list {
    padding-right: 1.5rem;
  }
}
</style>
